<template>
  <div class="container-fluid">
    <div class="row justify-content-center no-gutters main">
      <div class="col-md-8 col-lg-6 col-xl-4">
        <h4 class="text-center text-white mt-4 mb-4">
          Bienvenue<br>
          Merci de patienter pendant la connexion
        </h4>
        <div class="d-flex justify-content-center">
          <div class="spinner-border text-light" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios';

export default {
  name: 'Hmac',
  data() {
    return {
      // Module source
      source: this.$route.query.source ? this.$route.query.source : 'Portail',
      // Chemin de destination
      path: this.$route.query.path,

      // Paramètres d'authentification Hmac
      license: this.$route.query.license,
      terminal: this.$route.query.terminal,
      timestamp: this.$route.query.timestamp,
      mac: this.$route.query.mac,
      url: this.$route.query.url,
    };
  },
  methods: {
    authenticate() {
      axios.post('/auth/api/auth', JSON.stringify({
        license: this.license,
        terminal: this.terminal,
        timestamp: this.timestamp,
        mac: this.mac,
        url: this.url,
      }), { headers: { 'content-type': 'application/json' } }).then((response) => {
        axios.get(`/parametrage/api/urls/${response.data.data.storeId}`)
          .then((destination) => {
            let source;
            let hash;

            if (this.$parent.source) {
              if (destination.data[this.$parent.source].includes(destination.data.Customers)) {
                source = destination.data[this.$parent.source]
                  .replace(destination.data.Customers, destination.data.CustomersIS);
              } else if (destination.data[this.$parent.source]
                .includes(destination.data.services)) {
                source = destination.data[this.$parent.source]
                  .replace(destination.data.services, destination.data.Services);
              } else {
                source = destination.data[this.$parent.source];
              }
              hash = this.$parent.path !== '' ? new URL(this.$parent.path) : '';
            } else {
              this.$router.push({ name: 'Error', params: { errorType: 'source' } });
            }

            window.location.href = hash !== undefined ? `${source + hash}?mode=HMAC` : `${source}?mode=HMAC`;
          });
      })
        .catch(() => {
          this.$router.push({ name: 'Error', params: { errorType: 'hmac' } });
        });
    },
  },
  created() {
    this.authenticate();
  },
};
</script>
